<template>
  <!-- <div class="form-check form-switch"> -->
  <div>
    <input
      type="checkbox"
      class="btn-check"
      :id="`${props.name}-${props.index}`"
      :style="`min-width: ${props.width}px`"
      :checked="props.value"
      autocomplete="off"
      :disabled="props.disabled"
    />
    <label
      :class="`btn btn-outline-${props.color}`"
      :for="`${props.name}-${props.index}`"
      :style="`height: ${props.height}px; padding-top: ${props.paddingTop}px; padding-bottom: ${props.paddingBottom}px; width: 100%`"
      >{{ props.value ? props.onText : props.offText }}</label
    >
  </div>
  <!-- </div> -->
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
    default: 'btn-check-outlined',
  },
  index: {
    type: Number,
    required: true,
    default: 0,
  },
  onText: {
    type: String,
    default: '켜짐',
  },
  offText: {
    type: String,
    default: '꺼짐',
  },
  value: {
    type: Boolean,
    required: true,
    default: false,
  },
  width: {
    type: Number,
    default: 40,
  },
  height: {
    type: Number,
    default: 24,
  },
  paddingTop: {
    type: Number,
    default: 1,
  },
  paddingBottom: {
    type: Number,
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: 'primary',
  },
});
</script>

<style scoped></style>
